<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="placeholder || $t('message.status')"
    filterable
    clearable
    :size="size"
    :class="mode ? 'input__day' : 'input__night'"
    class="d-block"
  >
    <el-option
      v-for="(status, index) in statuses"
      :key="'status-' + index"
      :label="status.name"
      :value="status.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "status-salaries",
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    table_name: {
      default: null,
      type: String,
      required: true,
    },
    id: {
      default: null,
    }
    
  },
  mounted() {
    if (this.statuses){
        this.fetchStatuses();
    }
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        this.selected = this.id;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      statuses: "statussalaries/inventory",
      mode:'MODE'
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "statussalaries/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
   
    fetchStatuses() {
      const query = { table_name:  this.table_name };
      this.updateInventory(query)
        .then((res) => {                       
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
        });
    },
  },
};
</script>
